import * as types from './constants';

// Get Batch Message Template
export const getBatchMessageTemplateRequest = data => (
  { type: types.GET_BATCH_MESSAGE_TEMPLATE_REQUEST, payload: data }
);

export const getBatchMessageTemplateDone = data => (
  { type: types.GET_BATCH_MESSAGE_TEMPLATE_DONE, payload: data }
);

export const getBatchMessageTemplateFailed = errors => (
  { type: types.GET_BATCH_MESSAGE_TEMPLATE_FAILED, payload: errors }
);

// Update Batch Message Template
export const updateBatchMessageTemplateRequest = data => (
  { type: types.UPDATE_BATCH_MESSAGE_TEMPLATE_REQUEST, payload: data }
);

export const updateBatchMessageTemplateDone = data => (
  { type: types.UPDATE_BATCH_MESSAGE_TEMPLATE_DONE, payload: data }
);

export const updateBatchMessageTemplateFailed = errors => (
  { type: types.UPDATE_BATCH_MESSAGE_TEMPLATE_FAILED, payload: errors }
);

export const updateBatchMessageTemplateReset = () => (
  { type: types.UPDATE_BATCH_MESSAGE_TEMPLATE_RESET }
);